import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Auth } from "../primitives/auth";
import { HttpService } from "src/app/utils/http.service";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {log} from "node:util";

//https://pankaj-kumar.medium.com/angular-8-9-user-registration-and-login-example-and-tutoria-96e7a6615c48

@Injectable({ providedIn: "root" })
export class AuthenticationService {
    auth: Auth = null;

    public loadTokenFromLocalStorage() {
        const itemString = localStorage.getItem("currentUser");
        try {
            this.auth = JSON.parse(itemString);
        } catch (err) {
            console.error(err);
        }
    }

    public isAuthenticated() {
        if (this.auth === null) {
            this.loadTokenFromLocalStorage()
        }
        return !!this.auth;
    }

    public logout() {
        localStorage.removeItem("currentUser");
        this.auth = null;
    }

    public setAuthenticationToken(auth: Auth) {
        this.auth = auth;
        localStorage.setItem("currentUser", JSON.stringify(auth));
        console.log("set auth token")
    }

    public getAuthenticationToken() {
        console.log("get auth token")
        if (!this.auth) this.loadTokenFromLocalStorage()
        console.log("auth", this.auth)
        if (!this.auth) return null
        return this.auth.token.access_token
    }

    public async registerNewUser(email: string, displayName: string, password: string) {

    }

    public checkPasswordIsSecure(password: string) {
        return password.length > 8;
    }
}
